import React from 'react';
import BaseChoices from './BaseChoices.js';
import {v4 as uuidv4} from 'uuid';


class MultipleChoices extends BaseChoices {

    render() {
        const choices = this.props.choices.map((choice, index) => {
            return (
                <div className="choice col-md-6 col-sm-12" key={uuidv4()}>
                    <div className="multiple-choice" onClick={() => {this.handleClick(index);}}
                         idx={index}>{choice}</div>
                </div>
            );
        });

        return (
            <div id="choices-row" className="row">
                {choices}
            </div>
        );
    }
}

export default MultipleChoices;
